import React, { ChangeEvent, useEffect } from 'react';
import { Button, FormControl, IconButton, InputAdornment, MenuItem, Select, Switch, TextField } from '@mui/material';
import { useSelector } from 'react-redux';
import CouponBox from '../CouponBox';
import CouponConfigurableLabel from '../CouponConfigurableLabel';
import { useState, useCallback, useRef } from 'react';
import { openPopup } from '../../../../stateManagement/actions/popupActions';
import cameraIcon from "../../../../images/upload_themeColor6.png"
import { resetAllData, updateBannerActive, updateCurrentTab, updatePlaygroundMode, uploadBannerImage, uploadBannerPriority } from '../../../../stateManagement/actions/manageCouponActions';
import { getPriorityLabel, handleBannerSwitch, handleCloseButton, handleFileUpload, handlePriorityChange, handlePublish, handlePublishClickOnClone, handlePublishClickOnViewAndEdit, handlePublishCloneClick, handlePublishSchemePlayground, uploadDocument } from './service';
import { validateALLTabsData } from '../validationPopup/validationService';
import { bannerUploadActive, postScheme,isLargeExclusion,postOutletLists, editCouponDates, isOnlyDateUpdate } from '../../services/services';
import { labelMappings } from '../../utils/utils';
import { clearDesignationCache } from '../DefineCoupon/MarketDetails/service';
import { PublishPropTypes } from '../../types';
import ValidationPopUp from '../validationPopup/ValidationPopUp';
import ValidationContent from '../validationPopup/ValidationContent';
import { useNavigate } from 'react-router-dom';
import { ConfirmationPopUp } from '../../../../components/popup/confirmationPopUp';
import { ChannelkartNetworkPatch } from '../../../../services/networkService';
import { TranslationEnum, usePortalTranslation } from '../../../../providers/TranslationProvider';
import { Loader } from '../../../../components/loader/Loader';
import DownloadLoader from '../../../../components/popup/downloadLoader';
import { showDistributorDesignation } from '../DefineCoupon/MarketDetails/configData';


function BannerImageUpload(props: PublishPropTypes) {
    const { translate } = usePortalTranslation();
    const CUR_COMPONENT_COMMON="commonPortal";
    let navigate = useNavigate();
    const [fileUploaded, setFileUploaded] = useState<Blob>();
    const [selectedFile, setSelectedFile] = useState<string>("");
    const redux_banner_url = useSelector((state: any) => state?.manageCoupons?.data?.banner.uploadBanner.imageUrl);
    const redux_banner_priority = useSelector((state: any) => state?.manageCoupons?.data?.banner.uploadBanner.bannerPriority);
    const [imageIcon, setImageIcon] = useState<string>("");
    const [isLoading, setIsLoading] = useState(false);
    const { updateCurrentStep, dateChanged, setShowOverAndAboveBody } = props;
    const { data: banner, active: bannerActive } = useSelector((state: any) => state?.manageCoupons?.data?.banner.uploadBanner);
    const [publishLoading, setPublishLoading] = useState<boolean>(false);
    const [priority, setPriority] = useState(1);
    const { isSchemePlayground, couponEditType, couponId, deleteParent } = useSelector((state: any) => state?.manageCoupons?.data);
    const [validationErrors, setValidationErrors] = useState<{
        label: string;
        data: string;
    }[]>([]);
    const [ValidationPopUpOpen, setValidationPopUpOpen] = useState<boolean>(false);
    const redux_inclusion_file_url = useSelector((state: any) => state?.manageCoupons?.data?.inclusionFileUrl);
    const redux_exclusion_file_url = useSelector((state: any) => state?.manageCoupons?.data?.exclusionFileUrl);

    const ACCEPTED_FILE_TYPES = "image/png, image/jpeg";
    const authContext = localStorage.getItem("authContext") && JSON.parse(localStorage.getItem("authContext") as string);
    const fileInputRef = useRef() as React.MutableRefObject<HTMLInputElement>;
    const [openPublishConfirmModal, setOpenPublishConfirmModal] = useState<boolean>(false);
    const [modalMessage, setModalMessage] = useState<string>("");
    const [publishInProcess, setPublishInProcess] = useState(false);

    const generateBlob = useCallback(async () => {
        if (!bannerActive) return;

        const formData = new FormData();
        setIsLoading(true);
        formData.append("files", fileUploaded!, selectedFile);
        let fileUploadResponse;
        try {
            fileUploadResponse = await uploadDocument(formData);
        }
        catch (err) {
            openPopup('Alert', "Something went wrong, Try again");
            setFileUploaded(undefined);
            setSelectedFile("");
            setImageIcon("");
            if (fileInputRef.current) {
                fileInputRef.current.value = "";
            }
            throw new Error("Something went wrong, Try again");
        }
        const blobKey: string = fileUploadResponse[0];

        uploadBannerImage(blobKey);
        setIsLoading(false);
    }, [fileUploaded, selectedFile, authContext]);


    const handlePublishClick = async () => {

        const response = await validateALLTabsData();

        if(!bannerActive){
            setFileUploaded(undefined);
            setSelectedFile("");
            setPriority(1);
            uploadBannerImage("")
            uploadBannerPriority("")
            if (fileInputRef.current) {
                fileInputRef.current.value = "";
            }
        }

        if (bannerActive && (fileUploaded === null || fileUploaded === undefined)) {
            if (isLoading) setIsLoading(false);
            openPopup('Alert', translate(TranslationEnum.common_portal,"Please upload a file"));
            throw new Error("Select the Banner Image");
        }

        if (response?.length !== 0) {
            setValidationErrors(response);
            setValidationPopUpOpen(true);
            return;
        }

        const publishTimeout = setTimeout(() => {
            setPublishInProcess(true)
        }, 30000);

        try {
            setPublishLoading(true);
            if(isOnlyDateUpdate() && couponEditType === "edit") {
                const response: any = await editCouponDates();
                openPopup("Success", labelMappings["COUPON_UPDATE_SUCCESS"])

            } else {
                const requestBody: any = await postScheme(redux_inclusion_file_url, redux_exclusion_file_url);
                if (isLargeExclusion()) {
                    const schemeId: string = requestBody.schemeId;
                    let response = null;
                    if(redux_inclusion_file_url !== "" || redux_exclusion_file_url !== "") {
                        response = await postOutletLists(schemeId, redux_inclusion_file_url, redux_exclusion_file_url);
                    }
                    if(response !== null && (response.status === 200 || response.status === 201)) {
                        setPublishInProcess(false);
                        clearTimeout(publishTimeout);
                    }
                }
                
                    openPopup("Success", labelMappings["COUPON_UPLOADED_SUCCESS"])
                    if ("OAAC" in requestBody.extendedAttributes) {
                        setShowOverAndAboveBody({ open: true, body: requestBody });

                }
            }
            resetAllData(); // reset saved data not config data
            if(showDistributorDesignation()) clearDesignationCache(); // clear designation cache
            if (isSchemePlayground) {
                updatePlaygroundMode(true);
                updateCurrentTab('3');
            }
            else {
                updateCurrentTab('0'); // move to first tab
            }
            updateCurrentStep(0);
            setFileUploaded(undefined);
            setSelectedFile("");
            setPriority(1);
            if (fileInputRef.current) {
                fileInputRef.current.value = "";
            }
            if (couponEditType == "edit" || couponEditType == "clone") {
                navigate("/couponDashboard/liveCouponData");
            }
        } catch (err: any) {
            console.error(err);
            setPublishInProcess(false);
            openPopup("Error", err.message ?? "Some error occured while saving data")
        } finally {
            setPublishLoading(false);
            clearTimeout(publishTimeout);
        }

    }
    const handleClick = useCallback(() => {
        if(isLoading) setIsLoading(false);
        fileInputRef.current && fileInputRef.current.click();
    }, []);


    useEffect(() => {
        const uploadAndGenerateBlob = async () => {
            if (fileUploaded && selectedFile) {
                try {
                    const blobKey = await generateBlob();
                } catch (error) {
                    console.error('Error uploading file:', error);
                }
            }
        };

        uploadAndGenerateBlob();
    }, [fileUploaded, selectedFile, fileInputRef]);

    useEffect(() => {
        if (redux_banner_url) {
            setFileUploaded(new File([redux_banner_url], ""))
        }
        if (redux_banner_priority) {
            setPriority(redux_banner_priority)
        }
    }, []);
    
    return (
        <div className="file_upload_container">
            {publishLoading ? <Loader/> 
            :   <>         
            {bannerUploadActive() ? <>
            <CouponBox hideDropDown={true} open={bannerActive} disabled={isOnlyDateUpdate() && couponEditType === "edit" ? true : !bannerActive} showBorder={true} collapsible

                header={<>

                    <CouponConfigurableLabel text={'UPLOAD_BANNER'} style={{ color: 'inherit' }} />
                    <span style={{ margin: '0 10px' }}  onClick={(e) => { e.stopPropagation() }}>
                        <Switch onChange={(event)=>{handleBannerSwitch(event)}} checked={bannerActive}  disabled={isOnlyDateUpdate() && couponEditType === "edit"} style={{color: bannerActive ? "#1c7ea0" : ""}} />
                    </span>


                </>}>

                <div className="file_upload_div" onClick={handleClick} style={{ padding: '20px', height: '150px', cursor: 'pointer', position: 'relative' }}>
                    <input ref={fileInputRef} type="file" style={{ display: "none", height: "100" }} onChange={(event)=>{handleFileUpload(event,setFileUploaded,setSelectedFile,setImageIcon,fileInputRef)}} accept={ACCEPTED_FILE_TYPES} />
                    {fileUploaded && <span className="close-button" style={{ position: 'absolute', top: '0px', right: '10px', cursor: 'pointer', fontSize: '30px', color: '#333' }} onClick={(event)=>{handleCloseButton(event,fileInputRef,setFileUploaded,setSelectedFile,setPriority)}} >×</span>}
                    <div style={{ position: 'absolute', bottom: '0px', right: '10px', cursor: 'pointer', fontSize: '14px' }} >
                        Dimensions: 500 x 416
                    </div>
                    {fileUploaded ? (
                        <div>
                            <div className="image" >
                                <img width={"auto"} height={120} style={{objectFit:"cover"}} src={redux_banner_url} alt="Image not available" />
                            </div>

                        </div>
                    ) : (
                        <>
                            <div className="icon_and_text" >
                                <img width={50} height={45} src={cameraIcon}></img>
                                Upload banner image
                            </div>
                        </>
                    )}
                </div>

                <div className="display_blob_key">
                    <div className="textFieldOutline" style={{ backgroundColor: '#f3fcfb', display: 'flex', alignItems: "center", marginBottom: "10px", marginTop: "10px" }}>
                        <div style={{ display: "flex", alignItems: "center", height: "100%", borderRadius: "5px", padding: "0px 20px 0px 20px" }}>
                            <p style={{ whiteSpace: "nowrap", gap: "10", fontSize: '16px', alignItems: "center", justifyContent: "center", color: "#24c6b1", fontWeight: "bold" }}>Priority :</p>
                        </div>
                        <div className='priority_input' style={{ border: 'white 10px solid', width: "95%", borderRadius: "5px" }}>
                            <FormControl variant="outlined" size="small">
                                <Select
                                    value={priority}
                                    onChange={(event) => {
                                        handlePriorityChange(event,setPriority);
                                    }}
                                    displayEmpty
                                >
                                    <MenuItem value="" disabled>
                                        Priority
                                    </MenuItem>
                                    {Array.from({ length: 20 }, (_, i) => i + 1).map((number) => (
                                        <MenuItem key={number} value={number}>
                                            {number} - {getPriorityLabel(number)}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </div>
                    </div>
                </div>
            </CouponBox></> : ''}
            </> 
            }
            
                <div className="define-coupon-next-button-wrapper">
                    <Button disabled={publishLoading} variant='contained' onClick={()=>{handlePublish(isSchemePlayground,couponEditType,setOpenPublishConfirmModal,setModalMessage,handlePublishClick)}}>Publish</Button>
                </div>
            
            {publishInProcess ? (
                <DownloadLoader
                    message={"Data might be too large. Please wait..."}
                    openReportModal={publishInProcess}
                    setOpenReportModal={setPublishInProcess}
                />
            ) : null}
            
            <ConfirmationPopUp
                openConfirmModal={openPublishConfirmModal}
                setOpenConfirmModal={setOpenPublishConfirmModal}
                message={modalMessage}
                successMethod={() => {
                    couponEditType == "clone" ? handlePublishCloneClick(deleteParent,couponId,handlePublishClick): handlePublishClick()
                }}
                rejectMethod={() => { setOpenPublishConfirmModal(false) }}
            />
            <ValidationPopUp
                open={ValidationPopUpOpen}
                handleClose={() => {
                    setValidationPopUpOpen(false)
                    setValidationErrors([])
                }}
                content={<ValidationContent validationErrors={validationErrors} />}
            />

        </div>

    );
}



export default BannerImageUpload;
